<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Transactions History</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <TransactionHistoryTable mode="teller-transaction-history" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Cash Transactions History Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import TransactionHistoryTable from "../../components/Kleyton/Tables/TransactionsHistory/TransactionHistoryTable";

export default {
  page: {
    title: "Transactions History",
    meta: [{ name: "Transactions History", content: window.__env.app.description }]
  },
  components: {
    TransactionHistoryTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Transactions History",

      items: [
        {
          text: "Transactions History",
          href: "/"
        },
        {
          text: "Transactions History",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
